import * as React from 'react';
import { useHistory } from 'react-router-dom';
import {
	AppBar,
} from '@material-ui/core';
import axiosInstance from '../../axios/axios-instance';
import { clearStoreLogout } from '../../modules/login-reducer';
import { useSelector, useDispatch } from 'react-redux';
import { Store } from '../../modules/root-reducer';
import { makeStyles } from '@material-ui/styles';
import theme from '../../theme';
// import useScrollTrigger from '@material-ui/core/useScrollTrigger';
const font = "'Audiowide', cursive";

const BlankHeader = () => {
	const [clicked, setClicked] = React.useState<boolean>(false);
	const useStyles = makeStyles({
		header: {
			margin: '0px',
			padding: '10px 10px 10px 5vw',
			borderBottom: '1px solid black',
			backgroundColor: theme.palette.secondary.dark,
		},
		headerLogo: {
			float: 'left',
			paddingTop: '12px',
			cursor: 'pointer',
		},
		headerTitle: {
			fontFamily: font,
			float: 'left',
			marginLeft: '3vw',
			cursor: 'pointer',
		},
		headerButtons: {
			width: '100px',
			height: '50px',
		},
		showHeader: {
			transform: 'translateY(0)',
			transition: 'transform 20s',
		},
		hideHeader: {
			transform: 'translateY(-110%)',
			transition: 'transform 20s',
		},
		hidden: {
			display: 'none',
			visibility: 'hidden',
		},
		icons: {
			color: 'rgb(0, 0, 0)',
		},
		logo: {
			padding: '10px 5px',
			width: '50px',
			margin: '5px 0px 0px',
			backgroundColor: 'rgb(255, 255, 255)',
			borderRadius: '10px',
			border: '1px solid black',
		},
		fillerBox: {
			height: '100px',
		},
		list: {
			textAlign: 'center',
		},
		headerList: {
			listStyle: 'none',
			margin: '0px',
			padding: '0px',
			overflow: 'hidden',
			width: '100%',
		},
		dropdownWaffle: {
			margin: '15px 5vw 0px 0px',
		},
		// headerListA: {
		// 	display: 'block',
		// 	color: 'whitesmoke',
		// 	text-align: 'center',
		// 	padding: '16px',
		// 	textDecoration: 'none'
		// }
		dropdownList: {
			listStyle: 'none',
			margin: '0px',
			padding: '0px',
			overflow: 'hidden',
			width: '100%',
			display: clicked ? 'block' : 'none',
			visibility: clicked ? 'visible' : 'hidden',
		},
		// dropdownList li a: {
		// 	display: 'block',
		// 	color: 'black',
		// 	textAlign: 'center',
		// 	padding: '16px',
		// 	textDecoration: 'none',
		// },
		dropdownListTitles: {
			// display: clicked ? 'block' : 'inline',
			// visibility: clicked ? 'visible' : 'hidden',
			padding: '10px',
		},
		socialHeader: {
			margin: '20px 5vw 0px 0px',
			float: 'right',
		},
		['@media screen and (min-width: 1100px)']: {
			dropdownList: {
				display: 'none',
				visibility: 'hidden',
			},
			dropdownWaffle: {
				display: 'none',
				visibility: 'hidden',
			},
		},
		['@media screen and (max-width: 1100px)']: {
			Header: {
				fontSize: '11px',
			},
			socialHeader: {
				display: 'none',
				visibility: 'hidden',
			},
			dropdownWaffle: {
				display: 'block',
				visibility: 'visible',
			},
		},
	});
	// const trigger = useScrollTrigger({ threshold: 20 });
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();

	// ensure that you import Store from root-reducer.tsx, not from 'redux'!
	const token = useSelector<Store, string>(
		(store) => store.loginReducer.token
	);

	const [showLogin, setShowLogin] = React.useState<boolean>(true);

	React.useEffect(() => {
		setShowLogin(token === '');
	}, [token]);

	const handleSignUp = () => {
		resetDropdownList();
		history.push('/SignUp');
	};

	const handleTasks = () => {
		resetDropdownList();
		history.push('/Tasks');
	};

	const handleInvestigations = () => {
		resetDropdownList();
		history.push('/Investigations');
	};

	const handleTeams = () => {
		resetDropdownList();
		history.push('/Teams');
	};

	const handleExperts = () => {
		resetDropdownList();
		history.push('/Experts');
	};

	const handleLogout = () => {
		resetDropdownList();
		axiosInstance.defaults.headers.common.Authorization = '';
		dispatch(clearStoreLogout());
		localStorage.removeItem('token');
		history.push('Login');
	};

	const toggleDropdownList = () => {
		setClicked(!clicked);
	};

	const resetDropdownList = () => {
		setClicked(false);
	};

	return (
		<>
			<AppBar position='static' className={`${classes.header}`}>
				<ul className={classes.headerList}>
					<li className={classes.headerLogo}>
						{/* Logo goes here */}
						<img src='./favicon.ico' />
					</li>
					<li
						className={classes.headerTitle}
						onClick={() => history.push('/')}
					>
						<h1>COSINT</h1>
					</li>
				</ul>
			</AppBar>
		</>
	);
};

export default BlankHeader;
